import classNames from 'clsx';

import type { PropsWithChildren, ReactNode } from 'react';

import styles from './Card.module.css';

import { SectionNotification } from 'components/SectionNotification';

export interface CardProps {
  /** The element to use as a header. */
  header?: ReactNode;
  /** true to render the card with high contrast colors; otherwise, false. The default is false. */
  highContrast?: boolean;
  /** An optional notification to render. */
  notification?: ReactNode;
  /** The padding to use for the card. */
  padding?: 'small' | 'regular' | 'large';
  /** true to align the contents in the center; otherwise, false. */
  alignCenter?: boolean;
}

/** Represents a component to render a card. */
export const Card = ({
  children,
  header,
  highContrast,
  notification,
  padding = 'regular',
  alignCenter = false,
}: PropsWithChildren<CardProps>) => (
  <div
    className={classNames(styles['card'], {
      [styles['card--high-contrast']]: highContrast,
      [styles['card--regular']]: padding === 'regular',
      [styles['card--small']]: padding === 'small',
      [styles['card--large']]: padding === 'large',
      [styles['card--align-center']]: alignCenter,
    })}
  >
    {notification && <SectionNotification>{notification}</SectionNotification>}
    {header && <div className={styles['card-header']}>{header}</div>}
    {children}
  </div>
);
